const OPEN_CLASS = 'is-open';
const CONTAINER_SELECTOR = '[data-share-popover]';
const TOGGLE_SELECTOR = '.event-related__card-share-toggle';
const POPOVER_SELECTOR = '.event-related__card-share-popover';
const VIEWPORT_MARGIN = 8;

// The popover is `position: fixed` (not absolute inside the card) so it
// isn't clipped by the card's own `overflow: hidden` (used to round its
// corners) - this also keeps it correctly placed above the icon on mobile
// where cards are narrow and near the viewport edge.
const positionPopover = (toggle, popover) => {
    const toggleRect = toggle.getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();

    let left = toggleRect.left;
    let top = toggleRect.top - popoverRect.height - VIEWPORT_MARGIN;

    const maxLeft = window.innerWidth - popoverRect.width - VIEWPORT_MARGIN;
    left = Math.max(VIEWPORT_MARGIN, Math.min(left, maxLeft));

    if (top < VIEWPORT_MARGIN) {
        top = toggleRect.bottom + VIEWPORT_MARGIN;
    }

    popover.style.left = `${left}px`;
    popover.style.top = `${top}px`;
};

const closePopover = (container) => {
    container.classList.remove(OPEN_CLASS);
    container.querySelector(TOGGLE_SELECTOR)?.setAttribute('aria-expanded', 'false');
};

const closeAllPopovers = (except) => {
    document.querySelectorAll(`${CONTAINER_SELECTOR}.${OPEN_CLASS}`).forEach((container) => {
        if (container !== except) {
            closePopover(container);
        }
    });
};

export default function initializeSharePopover() {
    const containers = document.querySelectorAll(CONTAINER_SELECTOR);

    if (!containers.length) {
        return;
    }

    let activeContainer = null;

    const repositionActivePopover = () => {
        if (!activeContainer) {
            return;
        }

        positionPopover(
            activeContainer.querySelector(TOGGLE_SELECTOR),
            activeContainer.querySelector(POPOVER_SELECTOR)
        );
    };

    containers.forEach((container) => {
        const toggle = container.querySelector(TOGGLE_SELECTOR);
        const popover = container.querySelector(POPOVER_SELECTOR);

        if (!toggle || !popover) {
            return;
        }

        toggle.addEventListener('click', (event) => {
            event.stopPropagation();

            const isOpen = container.classList.contains(OPEN_CLASS);

            closeAllPopovers();

            if (isOpen) {
                activeContainer = null;
                return;
            }

            container.classList.add(OPEN_CLASS);
            toggle.setAttribute('aria-expanded', 'true');
            activeContainer = container;
            positionPopover(toggle, popover);
        });
    });

    document.addEventListener('click', (event) => {
        if (!event.target.closest(CONTAINER_SELECTOR)) {
            closeAllPopovers();
            activeContainer = null;
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeAllPopovers();
            activeContainer = null;
        }
    });

    window.addEventListener('resize', repositionActivePopover);
    window.addEventListener('scroll', repositionActivePopover, true);
}
